import { Fragment } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import Icon from "components/ShellV2/Icon";

export default function Crumbs({ items }) {
  return (
    <div className="rec-crumbs">
      <Icon name="home" />
      {items.map((it, idx) => {
        const last = idx === items.length - 1;
        const key = `${it.label}-${idx}`;
        let content = <span>{it.label}</span>;

        if (last) {
          content = <b>{it.label}</b>;
        } else if (it.to) {
          content = (
            <Link className="text-inherit no-underline font-normal" to={it.to}>
              {it.label}
            </Link>
          );
        }

        return (
          <Fragment key={key}>
            <Icon name="chevron_right" />
            {content}
          </Fragment>
        );
      })}
    </div>
  );
}

Crumbs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      to: PropTypes.string,
    })
  ).isRequired,
};
